import { custom, object, string, ZodIssueCode } from 'zod';

import { AudienceFragment } from '@occc/graphql';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

export type Audience = Pick<
  AudienceFragment,
  'uuid' | 'name' | 'status' | 'hasBeenBackFilled' | 'targetingAttributes'
> & {
  membershipCount?: number;
};

export const TargetFormSchema = object({
  // An empty uuid means "Universal" (all sub brands).
  subBrand: object({
    uuid: string().optional(),
  }).optional(),
  inAudience: object({
    id: string().optional(),
    audience: custom<Audience>().optional(),
  })
    .optional()
    .superRefine((value, ctx) => {
      if (!value?.audience?.uuid) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: IS_REQUIRED,
          path: ['audience'],
        });
      }
    }),
});
